import ReverseMortgagePLF from '../constants/reverse-mortgage-plf';

export default {
    multiplyAmounts(amount1, amount2) {
        return amount1 * amount2;
    },
    getLTV(age, interestRate) {
        let LTV;
        if (ReverseMortgagePLF != null && typeof ReverseMortgagePLF.item[0] != 'undefined' && ReverseMortgagePLF.item[0][`${age} ${interestRate}`]) {
            LTV = ReverseMortgagePLF.item[0][`${age} ${interestRate}`].factor;
        }
        return LTV;
    },
    getPayment(homevalue, remainingbalance, age, statecode, interestRate = 5.0, lendingLimit = 625500) {
        const factor = this.getLTV(age, interestRate);
        const miprate = 0.01;
        const originationfeerate = 0.022;
        const additionalfeerate = 0.02;
        const lendinglimit = lendingLimit;
        const lesserhomevaluelimit = lendinglimit < homevalue ? lendinglimit : homevalue;
        const principallimit = this.multiplyAmounts(lesserhomevaluelimit, factor);
        const orginationFee = Math.min(homevalue * originationfeerate, 6000);
        const mip = this.multiplyAmounts(principallimit, miprate);
        const additionalFee = this.multiplyAmounts(principallimit, additionalfeerate);
        const netprincipallimit = principallimit - (orginationFee + mip + additionalFee);
        const reversemortgageloan = Math.round((netprincipallimit - remainingbalance) * 100) / 100;
        return reversemortgageloan;
    },
    monthlyPaymentUsingLoanTermInYears(HomeValue, RemainingBalance, Age, StateCode) {
        return this.getPayment(HomeValue, RemainingBalance, Age, StateCode);
    },
};
